import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { createVuetify } from 'vuetify'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import './styles/main.scss'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import PassingOnLogo from './components/PassingOnLogo.vue'
import BrandName from './components/BrandName.vue'

// Pitch theme colors — derived from passingon-pitch-deck.html design system
// To roll back: swap themeColors back to the original block below
//
// Original colors (keep for reference):
//   primary: '#207a83', secondary: '#FDC578', accent: '#00ABBC',
//   surface: '#ffffff', background: '#f8fafc', headingFont: "'Alice', serif"
const themeColors = {
  primary: '#D4401A',      // brick red — brand CTA accent
  secondary: '#8C8C7A',    // warm grey
  accent: '#D4401A',       // same brick for consistency
  error: '#a62020',
  info: '#8C8C7A',
  success: '#36b373',
  warning: '#d97706',
  surface: '#FAF7F4',      // cream
  background: '#F2EDE8',   // warm off-white
  neutral200: '#E5E0D8',   // pitch mid-tone
  neutral400: '#A8A89A',   // pitch muted
  border: '#E5E0D8',       // pitch mid-tone
  gray100: '#EDEAE4',      // pitch panel
  gray500: '#8C8C7A',      // warm grey
  gray600: '#1C1C1C',      // pitch dark text
  white: '#FAF7F4',        // cream (replaces pure white)
  black: '#1C1C1C',        // pitch dark
  recording: '#ff5252',
  recordingStrong: '#f44336',
  recordingLight: '#ff8a80',
}

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: themeColors,
      },
    },
  },
  defaults: {
    VBtn: {
      variant: 'outlined',
    },
  },
})

const pinia = createPinia()

createApp(App)
  .use(router)
  .use(pinia)
  .use(vuetify)
  .component('PassingOnLogo', PassingOnLogo)
  .component('BrandName', BrandName)
  .mount('#app')
